(function () {
  'use strict';

  var product = {
    title: 'Mystery USA Forever Postage Stamps Assortment Bundle - 100 Count',
    url: '/products/usps-first-class-forever-postage-stamp-bundle-assortment',
    image: 'https://cdn.shopify.com/s/files/1/0701/1352/5926/files/1782940888579-hixlcrprb4a.webp?v=1782944433',
    variantId: '46542917107878',
    price: '$29.99',
    comparePrice: '$82.00'
  };

  function buildUpsell() {
    var target = document.querySelector('.template-index .sp-confidence');

    if (!target || target.getAttribute('data-sp-upsell-replaced') === 'true') {
      return;
    }

    target.setAttribute('data-sp-upsell-replaced', 'true');

    var section = document.createElement('section');
    section.className = 'sp-section sp-upsell';
    section.setAttribute('aria-labelledby', 'PostalUpsellTitle');

    section.innerHTML =
      '<div class="sp-shell">' +
        '<article class="sp-upsell__card sp-reveal is-visible">' +
          '<a class="sp-upsell__media" href="' + product.url + '" aria-label="' + product.title + '">' +
            '<img src="' + product.image + '" alt="' + product.title + '" loading="lazy" width="1000" height="1000">' +
            '<span class="sp-upsell__badge">Popular add-on</span>' +
          '</a>' +
          '<div class="sp-upsell__content">' +
            '<span class="sp-eyebrow">Complete your order</span>' +
            '<h2 id="PostalUpsellTitle">Add everyday postage to your collector haul.</h2>' +
            '<p class="sp-upsell__intro">Pair the featured mystery bundle with a 100-count Forever stamp assortment for letters, cards, invitations, and backup postage.</p>' +
            '<h3 class="sp-upsell__product-title"><a href="' + product.url + '">' + product.title + '</a></h3>' +
            '<div class="sp-upsell__price"><s>' + product.comparePrice + '</s><strong>' + product.price + '</strong><span>Save $52.01</span></div>' +
            '<ul class="sp-upsell__benefits" aria-label="Add-on benefits">' +
              '<li><span aria-hidden="true">✓</span> 100-count assortment</li>' +
              '<li><span aria-hidden="true">✓</span> Ready for everyday mail</li>' +
              '<li><span aria-hidden="true">✓</span> Extra variety for your order</li>' +
            '</ul>' +
            '<div class="sp-upsell__actions">' +
              '<form method="post" action="/cart/add" accept-charset="UTF-8" class="sp-upsell__form">' +
                '<input type="hidden" name="form_type" value="product">' +
                '<input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="id" value="' + product.variantId + '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button class="sp-upsell__add" type="submit">Add to cart — ' + product.price + '</button>' +
              '</form>' +
              '<a class="sp-upsell__details" href="' + product.url + '">View details <span aria-hidden="true">→</span></a>' +
            '</div>' +
            '<p class="sp-upsell__note">One-time purchase. Secure checkout is handled by Shopify.</p>' +
          '</div>' +
        '</article>' +
      '</div>';

    target.replaceWith(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildUpsell);
  } else {
    buildUpsell();
  }

  document.addEventListener('shopify:section:load', buildUpsell);
}());
